import { ActionKind, ScannedCode } from "../../types/Action";
import { useConfig } from "../ConfigProvider";
import { isValidOperatorBadge } from "./useBarcodeScanner";
import { requireState } from "../state/Common";
import {
    RootStateKind,
    ScanSubStateKind,
    useAnyState
} from "../state/StateProvider";

export const useOnScanProduct = () => {
    const { state, dispatch } = useAnyState();

    requireState(state, RootStateKind.Scan);

    const { subState } = state;
    const config = useConfig();

    return (scannedCode: ScannedCode) => {
        if (subState.kind === ScanSubStateKind.CartCheck) {
            if (isValidOperatorBadge(scannedCode)) {
                dispatch({ kind: ActionKind.ScanOperatorBadgeCartCheck });
                return;
            } else {
                console.warn(
                    `Scanned code ${scannedCode.code} ignored while in sub-state ${subState.kind}`
                );
                return;
            }
        } else if (
            subState.kind === ScanSubStateKind.ProcessPayment ||
            subState.kind === ScanSubStateKind.CheckingOut ||
            subState.kind === ScanSubStateKind.UnappliedCoupon
        ) {
            console.warn(
                `Scanned code ${scannedCode.code} ignored while in sub-state ${subState.kind}`
            );
            return;
        } else if (
            subState.kind === ScanSubStateKind.AgeVerification &&
            subState.status === "unconfirmed"
        ) {
            dispatch({
                kind: ActionKind.ScanId,
                identityDocumentScan: scannedCode,
                attemptedAction: subState.attemptedAction
            });
            return;
        }

        const couponCode = config.couponCodes.find(
            (c) => c === scannedCode.code
        );

        if (couponCode) {
            dispatch({
                kind: ActionKind.ApplyCoupon,
                code: couponCode
            });
            return;
        }

        dispatch({
            kind: ActionKind.AddProduct,
            payload: scannedCode
        });
    };
};
